// @flow
import { RatingExplanationButton as component } from './component'
import { setSidebarVisibility } from '../slidingpane/reducer'
import { connect } from 'react-redux'

const mapDispatchToProps = dispatch => {
  return {
    clickHandler: () => dispatch(setSidebarVisibility())
  }
}

const container = connect(
  undefined,
  mapDispatchToProps
)(component)

export { container as RatingExplanationButton }
